var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoGatewayPod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5324 26.698L2.7365 16.6392C2.50318 16.2343 2.36118 15.6414 2.36117 15.0001C2.36115 14.3588 2.50313 13.7659 2.7365 13.3609L8.5324 3.3021C8.76457 2.89918 9.20618 2.4806 9.76304 2.16035C10.3195 1.8403 10.9073 1.66671 11.3798 1.66671H22.926C23.3983 1.66671 23.986 1.84027 24.5426 2.16032C25.0995 2.48059 25.5412 2.89917 25.7734 3.30209L31.5692 13.3609C31.8025 13.7658 31.9445 14.3586 31.9445 15C31.9445 15.6413 31.8025 16.2342 31.5692 16.6392L25.7734 26.698C25.5412 27.1009 25.0996 27.5195 24.5428 27.8397C23.9863 28.1598 23.3985 28.3334 22.926 28.3334H11.3798C10.9075 28.3334 10.3198 28.1598 9.7632 27.8398C9.20626 27.5195 8.76457 27.1009 8.5324 26.698Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5324 26.698L2.7365 16.6392C2.50318 16.2343 2.36118 15.6414 2.36117 15.0001C2.36115 14.3588 2.50313 13.7659 2.7365 13.3609L8.5324 3.3021C8.76457 2.89918 9.20618 2.4806 9.76304 2.16035C10.3195 1.8403 10.9073 1.66671 11.3798 1.66671H22.926C23.3983 1.66671 23.986 1.84027 24.5426 2.16032C25.0995 2.48059 25.5412 2.89917 25.7734 3.30209L31.5692 13.3609C31.8025 13.7658 31.9445 14.3586 31.9445 15C31.9445 15.6413 31.8025 16.2342 31.5692 16.6392L25.7734 26.698C25.5412 27.1009 25.0996 27.5195 24.5428 27.8397C23.9863 28.1598 23.3985 28.3334 22.926 28.3334H11.3798C10.9075 28.3334 10.3198 28.1598 9.7632 27.8398C9.20626 27.5195 8.76457 27.1009 8.5324 26.698Z",
    stroke: "url(#paint0_linear_8581_9262)",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5324 26.698L2.7365 16.6392C2.50318 16.2343 2.36118 15.6414 2.36117 15.0001C2.36115 14.3588 2.50313 13.7659 2.7365 13.3609L8.5324 3.3021C8.76457 2.89918 9.20618 2.4806 9.76304 2.16035C10.3195 1.8403 10.9073 1.66671 11.3798 1.66671H22.926C23.3983 1.66671 23.986 1.84027 24.5426 2.16032C25.0995 2.48059 25.5412 2.89917 25.7734 3.30209L31.5692 13.3609C31.8025 13.7658 31.9445 14.3586 31.9445 15C31.9445 15.6413 31.8025 16.2342 31.5692 16.6392L25.7734 26.698C25.5412 27.1009 25.0996 27.5195 24.5428 27.8397C23.9863 28.1598 23.3985 28.3334 22.926 28.3334H11.3798C10.9075 28.3334 10.3198 28.1598 9.7632 27.8398C9.20626 27.5195 8.76457 27.1009 8.5324 26.698Z",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 1.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8581_9262",
    x1: 17.1528,
    y1: 0.833374,
    x2: 17.1528,
    y2: 29.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6560FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803FCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGatewayPod);
export default __webpack_public_path__ + "static/media/No Gateway Pod.4b11174092c0dff5167cf86d2712a1f7.svg";
export { ForwardRef as ReactComponent };